export default __webpack_public_path__ + "static/media/p4-13.7e586eac.png";